import { render, staticRenderFns } from "./communicationList.vue?vue&type=template&id=c2087d04&scoped=true"
import script from "./communicationList.vue?vue&type=script&lang=js"
export * from "./communicationList.vue?vue&type=script&lang=js"
import style0 from "./communicationList.vue?vue&type=style&index=0&id=c2087d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2087d04",
  null
  
)

export default component.exports